import {
  SYNC_ORPHANED_REQUEST, SYNC_ORPHANED_SUCCESS, SYNC_ORPHANED_FAILURE,
  SYNC_CUSTOMER_REQUEST, SYNC_CUSTOMER_SUCCESS, SYNC_CUSTOMER_FAILURE,
  SYNC_USER_REQUEST, SYNC_USER_SUCCESS, SYNC_USER_FAILURE,
  SYNC_BULK_REQUEST, SYNC_BULK_SUCCESS, SYNC_BULK_FAILURE
} from '../actions/sync'

const INITIAL_STATE = {
  orphanedData: null,
  error: null,
  loading: false
}

const syncReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SYNC_ORPHANED_REQUEST:
      return {
        ...state,
        orphanedData: null,
        error: null,
        loading: true
      }
    case SYNC_ORPHANED_SUCCESS:
      return {
        ...state,
        orphanedData: action.response,
        loading: false
      }
    case SYNC_ORPHANED_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case SYNC_CUSTOMER_REQUEST:
    case SYNC_USER_REQUEST:
    case SYNC_BULK_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case SYNC_CUSTOMER_SUCCESS:
    case SYNC_USER_SUCCESS:
    case SYNC_BULK_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case SYNC_CUSTOMER_FAILURE:
    case SYNC_USER_FAILURE:
    case SYNC_BULK_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state
  }
}

export default syncReducer
